// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { ProposalState } from "@/types/proposal";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Proposal } from "@/models/proposal";

const state: ProposalState = {
  single: new Proposal(),
  pagination: new Pagination(),
};

export const proposal: Module<ProposalState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
